// extracted by mini-css-extract-plugin
export default {"footer":"responsive-styles_footer__kkwes","innerFooter":"responsive-styles_innerFooter__ZrE+J","terms":"responsive-styles_terms__EEAwE"};